import React, { Fragment, useEffect, useRef } from 'react'
import Mainlogo_banner from './Sections/Mainlogo_banner'
import Site_about from './Sections/Site_about'
import Range_section from './Sections/Range_section'
import Portfolio from './Sections/Portfolio' 
import Show_case from './Sections/Show_case'
import Pricing_cards from './Sections/Pricing_cards'

export const Main_logo = () => {
  const bannerSectionRef = useRef(null);

  useEffect(() => {
    if (window.location.hash === '#bannerSection') {
      scrollToSection(bannerSectionRef);
    }
  }, []);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
    return (
      <>
      
       <Mainlogo_banner ref={bannerSectionRef}/>
      <Site_about/>
      <Range_section/>
      <Show_case/>
      <Pricing_cards/>
      <Portfolio/>
      </>
    )
}